<section class="section-pd register-form">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="trinka-title mb-0 text-center ">
                    <h1 class="mb-4">企業向けお問い合わせ</h1>
                    <p>ご要望をお聞かせください。弊社チームより折り返しご連絡いたします。</p>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-7 col-md-7 dflex">
                <div class="c-card enterpriseFormCard">
                    <div class="form-wrapper" *ngIf="formSection">
                        <form [formGroup]="contactForm" (ngSubmit)="sendContactUsForm()">
                            <div class="row">
                                <div class="col-12">
                                    <h5 class="md-title md-title1 mt-0">個人情報</h5>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>名前*</mat-label>
                                            <input matInput placeholder="" formControlName="contactFormName" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>メール*</mat-label>
                                            <input matInput placeholder="" formControlName="contactFormEmail" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>電話番号*（国際電話コードを含む）</mat-label>
                                            <input type="number" matInput placeholder="" formControlName="contactphoneNo" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>名称*</mat-label>
                                            <input matInput placeholder="" formControlName="DesignationTypes" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>組織名*</mat-label>
                                            <input matInput placeholder="" formControlName="contactFormSubjects" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <h5 class="md-title md-title1">要件の詳細</h5>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>ユーザー数</mat-label>
                                            <input matInput placeholder="" formControlName="countUsers" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group w-100" >
                                        <mat-form-field appearance="outline">
                                            <mat-label>月間ファイル数／容量</mat-label>
                                            <input matInput placeholder="" formControlName="monthlyCountVolume" class="form-control">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <h5 class="md-title">どのような機能やソリューションにご興味がありますか？ <small class="d-block">（該当するものすべてを選択してください）</small></h5>                                
                                </div>
                                <div class="col-sm-12 col-12">
                                    <div class="featuresBox mt-3">
                                        <ul>
                                            <li *ngFor="let feature of forIntegration">
                                              <mat-checkbox
                                                [checked]="isSelected('integrationFeatures', feature)"
                                                (change)="toggleFeature('integrationFeatures', feature, $event.checked)">
                                                {{ feature }}
                                              </mat-checkbox>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group textArea w-100" >
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>Additional Comments</mat-label>
                                            <textarea matInput formControlName="contactFormMessage"></textarea>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <input type="text" formControlName="website" style="display:none">
                            <div class="btn-group justify-content-center">
                                <button type="submit" class="filled-btn" [disabled]="isSubmitting">
                                    <div id="loading"></div>
                                    <span>送信</span>
                                </button>
                            </div>
                        </form>
                    </div>  
                    <div class="thank_section contact_us_form" *ngIf="thankSection" #thankSectionRef>
                        <div class="form-group">
                            <svg width="90px" height="90px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>checkmark-circle</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-102.000000, -1141.000000)" fill="#00ab48"> <path d="M124.393,1151.43 C124.393,1151.43 117.335,1163.73 117.213,1163.84 C116.81,1164.22 116.177,1164.2 115.8,1163.8 L111.228,1159.58 C110.85,1159.18 110.871,1158.54 111.274,1158.17 C111.677,1157.79 112.31,1157.81 112.688,1158.21 L116.266,1161.51 L122.661,1150.43 C122.937,1149.96 123.548,1149.79 124.027,1150.07 C124.505,1150.34 124.669,1150.96 124.393,1151.43 L124.393,1151.43 Z M118,1141 C109.164,1141 102,1148.16 102,1157 C102,1165.84 109.164,1173 118,1173 C126.836,1173 134,1165.84 134,1157 C134,1148.16 126.836,1141 118,1141 L118,1141 Z" id="checkmark-circle" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>
                            <h2>ありがとうございます！</h2>
                            <p>折り返しご連絡いたします。</p>
                        </div>
                    </div>
                </div>
                <p class="tnc-statement">このフォームを送信することにより、お客様は当社の<a href="https://www.trinka.ai/termsofservices" target="_blank" class="text-link" >利用規約</a>および<a href="https://www.trinka.ai/privacypolicy" target="_blank" class="text-link">プライバシーポリシー</a>に同意したものとみなされます。</p>
            </div>
            <div class="col-lg-5 col-md-5 dflex">
                <div class="c-card enterpriseFormContent list-wrapper-style-2">
                    <div class="enterpriseCard list-wrapper-content-2">
                        <h4>企業や教育機関の方ではありませんか？</h4>
                        <p>Trinka Premiumは、個人ユーザーや小規模・成長中のチーム向けに、高度なライティング支援を提供します。</p>
                        <a href="/pricing" class="link-text">
                            Trinka Premiumのプランを見る
                            <img src="assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                        </a>
                    </div>
                    <div class="enterpriseCard list-wrapper-content-2">
                        <h4>企業や教育機関の多様なニーズに応える、オーダーメイドの機能とソリューション</h4>
                        <ul class="list-item">
                            <li>完全なデータプライバシーとセキュリティコンプライアンスを備えた機密データ管理</li>
                            <li>ニーズに合わせて機能と価格をカスタマイズ</li>
                            <li>API、SDK、オンプレミスオプションとのシームレスな統合</li>
                            <li>Academic Integrity Suite、オフラインデスクトップアプリ、利用状況分析およびユーザー管理、ローカル請求機能など、専用のソリューションをご利用いただけます</li>
                            <li>独自のAIモデルやアプリケーションを構築し、知的財産権を確保</li>
                        </ul>
                    </div>
                    <div class="enterpriseCard list-wrapper-content-2">
                        <h4>世界中の主要機関、出版社、企業から支持されています</h4>
                        <ul class="clientLogos">
                            <li>
                                <img src="assets/images/enterprise-form/ieee.png" alt="IEEE" />
                            </li>
                            <li>
                                <img src="assets/images/enterprise-form/royal-chemistry.png" alt="royal society of chemistry" />
                            </li>
                            <li>
                                <img src="assets/images/enterprise-form/cshl.png" alt="CSHL" />
                            </li>
                            <li>
                                <img src="assets/images/enterprise-form/indegene.png" alt="indegene" />
                            </li>
                            <li>
                                <img src="assets/images/enterprise-form/takeda.png" alt="takeda" />
                            </li>
                            <li>
                                <img src="assets/images/enterprise-form/cbua.png" alt="cbua" />
                            </li>
                            <li>
                                <img src="assets/images/enterprise-form/myrma.png" alt="My rma" />
                            </li>
                            <li>
                                <img src="assets/images/enterprise-form/jsu.png" alt="JSU" />
                            </li>
                            <li>
                                <img src="assets/images/enterprise-form/university-of-johannesburg.png" alt="university-of-johannesburg" />
                            </li>
                        </ul>
                    </div>
                    <div class="enterpriseCard list-wrapper-content-2">
                        <h4>他に何かお探しですか？</h4>
                        <a href="/contactus" class="link-text">
                            サポートへのお問い合わせ
                            <img src="/assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>